import { Container, Button,Form, Alert,Table, Modal} from 'react-bootstrap';
import {Sida,Rubrik,ContentWrapper,Stycke,StyckeCompact} from "../ContentStyles";
import { FaFilePdf, FaReceipt, FaEnvelope,FaBars, FaUser } from 'react-icons/fa';
import React, {useMemo, useState } from 'react';
import {useParams, useNavigate} from 'react-router-dom';
import MaterialReactTable from 'material-react-table';
import useBackend, {CallAPI, Loading, SpinnerX} from '../../services/useBackend';

var typingTimeout = null;

export default function MyComponent() {
    const {loading, data, Refresh} =  useBackend('/api/admin/customers');

    const [modalshow,  setModalshow] = useState(false);
    const initModal = () => { return setModalshow(!modalshow) } 
    const [modalText, setModalText] = useState({Guid:null, Name:"", SSN:"", Banned:true, CustomerAge:0, eMail:""});    

    const navigate = useNavigate();

    const operateLockClick = (event, rowData)  =>  {
        setModalText(rowData.original); 
        setModalshow(!modalshow);
    }

    function handleChange(event){
        clearTimeout(typingTimeout);
        typingTimeout = setTimeout(handleSave, 475);
    }

    function handleSave(){
        const ProductForm = document.getElementById('ProductForm');
        const formData = new FormData(ProductForm);

        const formDataObj = Object.fromEntries(formData.entries());
        formDataObj.Banned = formData.has('Banned') ? true : false;

        CallAPI('/api/admin/customer/'+modalText.Guid,"PATCH",JSON.stringify(formDataObj));
        Refresh();
    }
    
    const columns = useMemo(() => [
        { size: 20, accessorKey: 'SSN',   header: 'Personnummer', enableColumnActions: false },
        { size: 20, accessorKey: 'Name',  header: 'Namn' },
        { size: 20, accessorKey: 'eMail',  header: 'Email' },
        { size: 20, accessorKey: 'Banned',  header: 'Spärrad' },
        // { size: 20, header: 'Editera', columnDefType: 'display', enableColumnActions: false,            
        //     Cell: ({ row }) => ( <span style={{padding:5}} className='sub_' customerguid={row.original.Guid} onClick={operateLockClick} title="Info "><FaUser /></span> ),
        // },                   
      ]
    );       

    if (!loading) {
        return (
            <ContentWrapper>

                <Modal show={modalshow} onHide={initModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>{modalText.Name}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={handleSave} id="ProductForm">

                            <Form.Group className="mb-3" >
                                <Form.Label>Namn (<small>{modalText.SSN}</small>)</Form.Label>
                                <Form.Control type="text" name="Name" placeholder="Namn"  defaultValue={modalText.Name} onChange={handleChange} />
                            </Form.Group>

                            <Form.Group className="mb-3" >
                                <Form.Label>Email</Form.Label>								
                                <Form.Control type="text" name="eMail" placeholder="Email" defaultValue={modalText.eMail} onChange={handleChange} />
                            </Form.Group>

                            <Form.Group className="mb-3" >
                                <Form.Label>Ålder</Form.Label>								
                                <Form.Control type="text" name="eMail" placeholder="Email" defaultValue={modalText.CustomerAge} disabled />
                            </Form.Group>  					
                        
                            <Form.Group className="mb-3" >
                                <Form.Check type="switch" name="Banned" id="Banned" label="Spärra användare" defaultChecked={modalText.Banned} onChange={handleChange} />
                            </Form.Group>
                        </Form> 	                        
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="_" onClick={()=>navigate("/customer/"+modalText.Guid)}>Mer info</Button>
                        <Button variant="danger" onClick={initModal}>Close</Button>
                    </Modal.Footer>
                </Modal>

                <Container>
                    <Sida>
                        <MaterialReactTable  columns={columns} data={data.Customers}
                            muiTablePaginationProps={{ showFirstButton: false, showLastButton: false, labelRowsPerPage:"Rader"}}
                            renderTopToolbarCustomActions={() => (<Rubrik>Kunder</Rubrik>)}
                            initialState={{ pagination: { pageSize: 25 }, density: 'compact', columnVisibility: { Banned: false, eMail: false },  }}
                            muiTablePaperProps={{elevation: 0, sx: {borderRadius: '0',border: '0px dashed #e0e0e0'} }} 
                            muiTableBodyRowProps={({ row }) => ({
                            onClick: (event) => {
                                operateLockClick(event, row);
                                //console.info(event, row.original.Guid);
                                },
                                sx: {
                                    cursor: 'pointer', //you might want to change the cursor too when adding an onClick
                                },
                            })}                            
                        />
                    </Sida>
                </Container>                
            </ContentWrapper>
        );
    } else {
        return (<Loading />);        
    }
}